import React from 'react';
import LeaderFlipCards from '../components/leadersFlipCards';

const leadersFlipCardsPage: React.FC = () => {
  return <LeaderFlipCards />;
};

export default leadersFlipCardsPage;
